<template>
  <div class="py-20 h-full">
    <div
      class="card"
      :style="{
        backgroundImage: 'url(/img/party.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '400px',
      }"
    >
      <div class="p-10 text-white" style="background-color: rgba(0,0,0,0.75)">
        <h1 class="">
          Get what you want for Christmas
        </h1>
        <p class="font-size-18">
          Manage your Christmas and birthday presents with ease!
        </p>

        <router-link class="btn btn-primary" to="/events"
          >Log in now</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeComponent",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
